import { createClient } from '@supabase/supabase-js';

const normalizeEnvValue = (value) => {
  if (typeof value !== 'string') return value;
  return value.trim().replace(/^['"`](.*)['"`]$/, '$1');
};

const supabaseUrl = normalizeEnvValue(process.env.REACT_APP_SUPABASE_URL);
const supabaseKey = normalizeEnvValue(process.env.REACT_APP_SUPABASE_KEY);

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Las variables de entorno REACT_APP_SUPABASE_URL y REACT_APP_SUPABASE_KEY son requeridas');
}

const createBrowserSupabaseClient = () =>
  createClient(supabaseUrl, supabaseKey, {
    auth: {
      persistSession: false,
      autoRefreshToken: false,
      detectSessionInUrl: false,
      storageKey: 'tadmin-supabase-query-auth',
    },
    global: {
      headers: {
        apikey: supabaseKey,
      },
    },
  });

const createBrowserAuthSupabaseClient = () =>
  createClient(supabaseUrl, supabaseKey, {
    auth: {
      storageKey: 'tadmin-supabase-auth',
    },
    global: {
      headers: {
        apikey: supabaseKey,
      },
    },
  });

const globalSupabase = window;

if (!globalSupabase.__tadminSupabaseClient) {
  globalSupabase.__tadminSupabaseClient = createBrowserSupabaseClient();
}

if (!globalSupabase.__tadminAuthSupabaseClient) {
  globalSupabase.__tadminAuthSupabaseClient = createBrowserAuthSupabaseClient();
}

export const supabase = globalSupabase.__tadminSupabaseClient;
export const authSupabase = globalSupabase.__tadminAuthSupabaseClient;
export { supabaseKey, supabaseUrl };

// Función auxiliar para retry con backoff
export const retryWithBackoff = async (fn, maxRetries = 3, baseDelay = 1000) => {
  for (let i = 0; i < maxRetries; i++) {
    try {
      return await fn();
    } catch (error) {
      if (i === maxRetries - 1) throw error;
      
      const delay = baseDelay * Math.pow(2, i);
      console.warn(`Intento ${i + 1} falló, reintentando en ${delay}ms:`, error.message);
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }
};
